// extracted by mini-css-extract-plugin
module.exports = {"aboutWrapper":"about_aboutWrapper__JIJ2m","aboutTextBase":"about_aboutTextBase__2ZGaN","aboutTextHeavy":"about_aboutTextHeavy__YHRgR"};